import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4 col-sm-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "title ms-15" }
const _hoisted_7 = { class: "fw-black mb-8 lh-1" }
const _hoisted_8 = { class: "col-md-4 col-sm-6" }
const _hoisted_9 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_10 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "title ms-15" }
const _hoisted_13 = { class: "fw-black mb-8 lh-1" }
const _hoisted_14 = { class: "col-md-4 col-sm-6" }
const _hoisted_15 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_16 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "title ms-15" }
const _hoisted_19 = { class: "fw-black mb-8 lh-1" }
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 mb-20" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_23 = { class: "col-md-8" }
const _hoisted_24 = { class: "chart" }
const _hoisted_25 = { class: "col-md-2 col-sm-6" }
const _hoisted_26 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_27 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = { class: "title ms-15" }
const _hoisted_30 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_31 = { class: "fw-black mb-8 lh-1" }
const _hoisted_32 = { class: "col-md-2 col-sm-6" }
const _hoisted_33 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_34 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "title ms-15" }
const _hoisted_37 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_38 = { class: "fw-black mb-8 lh-1" }
const _hoisted_39 = { class: "col-md-2 col-sm-6" }
const _hoisted_40 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_41 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = { class: "title ms-15" }
const _hoisted_44 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_45 = { class: "fw-black mb-8 lh-1" }
const _hoisted_46 = { class: "col-md-2 col-sm-6" }
const _hoisted_47 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_48 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = { class: "title ms-15" }
const _hoisted_51 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_52 = { class: "fw-black mb-8 lh-1" }
const _hoisted_53 = { class: "col-md-2 col-sm-6" }
const _hoisted_54 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_55 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = { class: "title ms-15" }
const _hoisted_58 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_59 = { class: "fw-black mb-8 lh-1" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_63 = { class: "card-header" }
const _hoisted_64 = { class: "mb-25 fw-black" }
const _hoisted_65 = { class: "card-body" }
const _hoisted_66 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_67 = { class: "fw-black" }
const _hoisted_68 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_69 = { class: "fw-black" }
const _hoisted_70 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_71 = { class: "fw-black" }
const _hoisted_72 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_73 = { class: "fw-black text-danger" }
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_76 = { class: "card-header" }
const _hoisted_77 = { class: "mb-25 fw-black" }
const _hoisted_78 = { class: "card-body" }
const _hoisted_79 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_80 = { class: "fw-black" }
const _hoisted_81 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_82 = { class: "fw-black" }
const _hoisted_83 = { class: "mb-20 d-flex align-items-center justify-content-between" }
const _hoisted_84 = { class: "fw-black" }
const _hoisted_85 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_86 = { class: "fw-black text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mb-20" }, "Statistiques Générals", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" })
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Colis ", -1)),
                _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.dashData?.totalParcels ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" })
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Colis livrés ", -1)),
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.dashData?.totalParcels_livred ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-info" }, [
                _createElementVNode("i", { class: "flaticon-sterile-box" })
              ], -1)),
              _createElementVNode("div", _hoisted_18, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Colis Reportés Aujourd'hui ", -1)),
                _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.dashData?.POSTPONED ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }, [
              _createElementVNode("div", { class: "title" }, [
                _createElementVNode("h5", { class: "card-title fw-black mb-0" }, "Votre Taux de livraiosn")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_apexchart, {
                    type: "radialBar",
                    height: "200",
                    options: _ctx.goalOverviewRadialBar,
                    series: _ctx.goalOverviewRadialBar.series
                  }, null, 8, ["options", "series"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                class: "icon position-relative rounded-circle text-center",
                style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.DISTRIBUTION?.color + ' !important',
              })
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
              ]), 4),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DISTRIBUTION?.name ??
                  "En Distribution"), 1),
                _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DISTRIBUTION?.num ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", {
                class: "icon position-relative rounded-circle text-center",
                style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.IN_PROGRESS?.color + ' !important',
              })
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
              ]), 4),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.dashData?.ParcelsStatus?.IN_PROGRESS?.name ?? "En Cours"), 1),
                _createElementVNode("h4", _hoisted_38, _toDisplayString(_ctx.dashData?.ParcelsStatus?.IN_PROGRESS?.num ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", {
                class: "icon position-relative rounded-circle text-center",
                style: _normalizeStyle({
                color:
                  _ctx.dashData?.ParcelsStatus?.DELIVERED?.color + ' !important',
              })
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
              ]), 4),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DELIVERED?.name ?? "Livrés"), 1),
                _createElementVNode("h4", _hoisted_45, _toDisplayString(_ctx.dashData?.ParcelsStatus?.DELIVERED?.num ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", {
                class: "icon position-relative rounded-circle text-center",
                style: _normalizeStyle({
                color: _ctx.dashData?.ParcelsStatus?.REFUSE?.color + ' !important',
              })
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
              ]), 4),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.dashData?.ParcelsStatus?.REFUSE?.name ?? "Refusés"), 1),
                _createElementVNode("h4", _hoisted_52, _toDisplayString(_ctx.dashData?.ParcelsStatus?.REFUSE?.num ?? 0), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", {
                class: "icon position-relative rounded-circle text-center",
                style: _normalizeStyle({
                color: _ctx.dashData?.ParcelsStatus?.RETURNED?.color + ' !important',
              })
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "flaticon-sterile-box" }, null, -1)
              ]), 4),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.dashData?.ParcelsStatus?.RETURNED?.name ?? "Retournés"), 1),
                _createElementVNode("h4", _hoisted_59, _toDisplayString(_ctx.dashData?.ParcelsStatus?.RETURNED?.num ?? 0), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _cache[13] || (_cache[13] = _createElementVNode("h6", { class: "card-title" }, "Total Bons Paiment Payé (Livreur)", -1)),
            _createElementVNode("h6", _hoisted_64, _toDisplayString(_ctx.dashData?.totalNotePaid ?? 0) + " Bons ", 1)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-success text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-sterile-box\"></i></div><div><h6 class=\"mb-0 fw-medium\">Colis</h6><small class=\"text-muted\">Total Colis</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.dashData?.payn_l_parcels ?? 0) + " Colis ", 1)
            ]),
            _createElementVNode("div", _hoisted_68, [
              _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-danger text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Crbt</h6><small class=\"text-muted\">Total Crbt</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.dashData?.payn_l_crbt ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
            ]),
            _createElementVNode("div", _hoisted_70, [
              _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-primary text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-express-delivery\"></i></div><div><h6 class=\"mb-0 fw-medium\">Frais</h6><small class=\"text-muted\">Total Frais</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.dashData?.payn_l_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
            ]),
            _createElementVNode("div", _hoisted_72, [
              _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-info text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Total</h6><small class=\"text-muted\">Total</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.dashData?.payn_l_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "card-title" }, "Total Bons Paiment Non Payé (Livreur)", -1)),
            _createElementVNode("h6", _hoisted_77, _toDisplayString(_ctx.dashData?.totalNoteNotPaid ?? 0) + " Bons ", 1)
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-success text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-sterile-box\"></i></div><div><h6 class=\"mb-0 fw-medium\">Colis</h6><small class=\"text-muted\">Total Colis</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.dashData?.payn_l_not_parcels ?? 0) + " Colis ", 1)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-danger text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Crbt</h6><small class=\"text-muted\">Total Crbt</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.dashData?.payn_l_not_crbt ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
            ]),
            _createElementVNode("div", _hoisted_83, [
              _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-primary text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-express-delivery\"></i></div><div><h6 class=\"mb-0 fw-medium\">Frais</h6><small class=\"text-muted\">Total Frais</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.dashData?.payn_l_not_fees ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
            ]),
            _createElementVNode("div", _hoisted_85, [
              _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"icon position-relative rounded-circle text-center bg-info text-white me-15\" style=\"width:42px;height:42px;display:flex;align-items:center;justify-content:center;\"><i class=\"flaticon-money\"></i></div><div><h6 class=\"mb-0 fw-medium\">Total</h6><small class=\"text-muted\">Total</small></div></div>", 1)),
              _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.dashData?.payn_l_not_total ?? 0) + " " + _toDisplayString(_ctx.dashData?.devis?.devis ?? ""), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}